import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
// redux
import { useDispatch } from 'react-redux';

// @mui
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
// hooks
import useCollapseDrawer from 'hooks/useCollapseDrawer';
import useAuth from 'hooks/useAuth';

// config
import { HEADER, NAVBAR } from 'config';

// redux
import { getAllActions, getAllFunctions, getAllType, setConfig } from 'redux/slices/All';

import NavbarVertical from './navbar/NavbarVertical';

// ----------------------------------------------------------------------

const MainStyle = styled('main', {
  shouldForwardProp: (prop) => prop !== 'collapseClick'
})(({ collapseClick, theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.blue,
  paddingTop: HEADER.MOBILE_HEIGHT + 24,
  paddingBottom: HEADER.MOBILE_HEIGHT + 24,
  [theme.breakpoints.up('lg')]: {
    paddingLeft: 16,
    paddingRight: 16,
    paddingTop: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    paddingBottom: HEADER.DASHBOARD_DESKTOP_HEIGHT + 24,
    width: `calc(100% - ${NAVBAR.DASHBOARD_WIDTH}px)`,
    transition: theme.transitions.create('margin-left', {
      duration: theme.transitions.duration.shorter
    }),
    ...(collapseClick && {
      marginLeft: NAVBAR.DASHBOARD_COLLAPSE_WIDTH
    })
  }
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const { collapseClick } = useCollapseDrawer();
  const dispatch = useDispatch();
  const { user } = useAuth();
  useEffect(() => {
    async function fetchData() {
      dispatch(getAllActions());
      dispatch(getAllFunctions());
      dispatch(getAllType());
      dispatch(setConfig({ nbItemPerPage: parseInt(user.nb_item_per_page, 10), current: user }));
    }
    fetchData();
  }, [dispatch, user]);

  return (
    <Box
      sx={{
        display: { lg: 'flex' },
        minHeight: { lg: 1 }
      }}
    >
      <NavbarVertical />
      <MainStyle collapseClick={collapseClick}>
        <Outlet />
      </MainStyle>
    </Box>
  );
}
